import PropTypes from "prop-types";
import React, { Component } from "react";

class ToggleButton extends Component {
  render() {
    return (
      <div className="apl-floating-box">
        {this.props.children}
      </div>
    );
  }
}

ToggleButton.propTypes = {
  children: PropTypes.object,
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./components/common/FloatingBox.js